/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useMemo, useState } from 'react';
import Table from '@/components/Table/Table';

import { useTranslation } from 'react-i18next';
import { getHeaderColumnsGroup, tableColumns } from './tableColumns';
import {
  getHeaderColumnsGroup as getHistoryHeaderColumnsGroup,
  tableColumns as historyTableColumns,
  tableFilters as historyTableFilters,
} from '../SearchByShip/ModificationsHistory/getTableModificationHistory';
import styles from './ScheduleTable.module.scss';
import { Schedule } from '../types';
import { tableFilters } from './tableFilters';

type ScheduleTableProps = {
  isLoading: boolean;
  data?: Schedule[];
  isHistory?: boolean;
  showDetail?: boolean;
};

const ScheduleTable: FC<ScheduleTableProps> = ({
  isLoading,
  data,
  isHistory,
  showDetail,
}) => {
  const { t } = useTranslation('schedule');
  const [parsedData, setParsedData] = useState<Schedule[]>([]);

  const headerColumnsGroup = isHistory
    ? getHistoryHeaderColumnsGroup(t)
    : getHeaderColumnsGroup(t, showDetail);

  const parseDate = (date: string) => {
    if (!date) return null;
    const response = new Date(date);
    if (response.getTime() < 0) return null;
    return response;
  };

  useEffect(() => {
    if (data) {
      const newData = data.map((item: any) => {
        const {
          comienzoOperaciones,
          finOperaciones,
          fechaFinDescarga,
          aperturaStacking,
          cierreStacking,
          cutOff,
          ultimoCambio,
          ...rest
        } = item;

        return {
          ...rest,
          ultimoCambio: parseDate(ultimoCambio),
          comienzoOperaciones: parseDate(comienzoOperaciones),
          finOperaciones: parseDate(finOperaciones),
          fechaFinDescarga: parseDate(fechaFinDescarga),
          aperturaStacking: parseDate(aperturaStacking),
          cierreStacking: parseDate(cierreStacking),
          cutOff: parseDate(cutOff),
        };
      });
      setParsedData(newData);
    }
  }, [data]);

  const filteredTableColumns = useMemo(() => {
    const columns = [...tableColumns];
    if (showDetail) return columns;

    columns.pop();
    return columns;
  }, [showDetail]);

  return (
    <div className={styles.scheduleTable}>
      <Table
        columns={isHistory ? historyTableColumns : filteredTableColumns}
        data={parsedData}
        isLoading={isLoading}
        headerColumnGroup={headerColumnsGroup}
        className={!isHistory ? styles.table : undefined}
        filterDisplay="menu"
        filters={isHistory ? historyTableFilters : tableFilters}
      />
    </div>
  );
};

export default ScheduleTable;
